import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { styled } from '@styledComponents';
import { variant } from 'styled-system';
import { TypographyVariant } from '@components/themes';
import { Text } from '@components/typography';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { ReactComponent as SearchIcon } from './search.svg';

export const AvatarImageContainer = styled(Box)`
  height: 94px;
  width: 94px;
  ${themeMediaQuery('below_sm')} {
    width: 56px;
    height: 56px;
  }
`;

export const StyledCoupleAvatar = styled.img`
  width: 94px;
  height: 94px;
  object-fit: cover;
  border-radius: 50%;
  ${themeMediaQuery('below_sm')} {
    width: 56px;
    height: 56px;
  }
`;

export const ScalingInput = styled.input<{ variant: TypographyVariant }>`
  ${variant({ scale: 'typography' })};
  width: 100%;
  border: 0;
  padding: ${themeSpace(7)} ${themeSpace(14)} ${themeSpace(7)} 7rem;
  color: ${themeColor('humana5')};
  caret-color: ${themeColor('yellow5')};
  transition: all 0.1s linear;
  outline: none;
  font-weight: bold;
  font-size: 64px;
  line-height: 54px;
  letter-spacing: -0.005em;
  margin-top: ${themeSpace(5)};
  margin-bottom: ${themeSpace(5)};
  background-color: #ffffff;
  border-radius: 16px;

  ::placeholder {
    color: #e6b69b;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #e6b69b;
  }
  ${themeMediaQuery('below_sm')} {
    font-size: 30px;
    padding: ${themeSpace(6)} ${themeSpace(10)} ${themeSpace(6)} ${themeSpace(5)};
  }
  :focus::placeholder {
    color: transparent;
  }
`;

export const StyledSearchIcon = styled(SearchIcon)`
  position: absolute;
  left: ${themeSpace(7)};
`;

export const SearchForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-self: center;
  padding-left: 50px;
  padding-right: 50px;
  margin-top: ${themeSpace(14)};
  margin-bottom: ${themeSpace(5)};
  margin-left: auto;
  margin-right: auto;
  ${themeMediaQuery('below_sm')} {
    padding-left: 25px;
    padding-right: 25px;
    margin-top: ${themeSpace(13)};
  }
`;

export const SearchFormContainer = styled(Box)`
  width: 70%;
  max-width: 1250px;
  justify-content: center;
  justify-self: center;
  align-self: center;

  ${themeMediaQuery('sm')} {
    width: 100%;
  }

  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const ErrorDetail = styled(Text)`
  color: #b2364a;
  margin-top: ${themeSpace(7)};
  margin-bottom: ${themeSpace(5)};
`;

export const StyledFindButton = styled.button`
  padding: 0;
  background: none;
  border: none !important;
  width: 48px;
  height: 39px;
  margin: 0 ${themeSpace(7)};

  ${themeMediaQuery('below_sm')} {
    width: 24px;
    height: 19px;
    margin: 0;
    margin-right: ${themeSpace(5)};
  }
`;

export const StyledFindIcon = styled.img`
  width: 100%;
  height: 100%;
`;

export const StyledCloseButton = styled.button`
  height: 24px;
  width: 25px;
  padding: 0;
  border: none;

  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const ActionButtons = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
`;

export const FlexInputContainer = styled(Flex)`
  position: relative;
  width: 100%;
  justify-content: center;
`;

export const NoDataDetailText = styled(Text)`
  margin-bottom: 25px;
  font-size: 17px;
`;

export const SuggestionsContainer = styled(Box)`
  max-width: 625px;
  padding-right: 25px;
`;

export const RightBoulderContainer = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;
